export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    /** Kontaktformular */
    $('#contact-form form').on('submit', function( event ){
      event.preventDefault();

      $.ajax({
        // eslint-disable-next-line no-undef
        url: staerk.api_url + 'contact/save',
        method: 'POST',
        data: {
          // eslint-disable-next-line no-undef
          nonce     : staerk.api_nonce,
          title     : $('input[name="title"]:checked').val(),
          company   : $('input[name="company"]').val(),
          firstname : $('input[name="firstname"]').val(),
          lastname  : $('input[name="lastname"]').val(),
          email     : $('input[name="email"]').val(),
          phone     : $('input[name="phone"]').val(),
          message   : $('textarea[name="message"]').val(),
          user_agent: window.navigator.userAgent,
          ip_address: $('input[name="ip_address"]').val(),
        },
        beforeSend: function( xhr ) {
          // eslint-disable-next-line no-undef
          xhr.setRequestHeader( 'X-WP-Nonce', staerk.api_nonce );
        },
        success: function (response) {
          if ( response.success === true ) {
            console.log(response);
          }
        },
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js